import React from 'react'
import style from './InformationAboutСompany.module.scss'
export default function InformationAboutCompany({nextBlockRef}) {
    return (
       <div ref={nextBlockRef} className='container'>
           <div className={style.information}>
               <h2 className={style.title}>SQN <span>–</span> юридическая фирма, которая предлагает индивидуальные решения</h2>
           </div>
       </div>
    )
}
